import script from "./NewsPageObjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageObjectList.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageObjectList.vue?vue&type=style&index=0&id=15171773&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15171773"]])

export default __exports__